import axios from "axios";
import { authHeader } from "./auth-header";

const api = () => process.env.REACT_APP_API_URL || "";

const clean = (v) => (v == null || String(v).trim() === "" ? null : String(v).trim());

function buildScopeParams({ from, to, storeId, limit } = {}) {
  const params = {};
  const f = clean(from);
  const t = clean(to);
  if (f) params.from = f;
  if (t) params.to = t;
  if (storeId != null && String(storeId).trim() !== "") params.storeId = storeId;
  if (limit != null) params.limit = limit;
  return params;
}

export const overview = (params = {}) =>
  axios.get(`${api()}analytics/overview`, { headers: authHeader(), params: buildScopeParams(params) });

export const ordersByStatus = (params = {}) =>
  axios.get(`${api()}analytics/orders-by-status`, {
    headers: authHeader(),
    params: buildScopeParams(params),
  });

export const topProducts = (params = {}) =>
  axios.get(`${api()}analytics/top-products`, {
    headers: authHeader(),
    params: buildScopeParams({ ...params, limit: params.limit ?? 10 }),
  });

export const salesByCategory = (params = {}) =>
  axios.get(`${api()}analytics/sales-by-category`, {
    headers: authHeader(),
    params: buildScopeParams({ ...params, limit: params.limit ?? 20 }),
  });

export const monthlyPlatformEarning = (params = {}) =>
  axios.get(`${api()}analytics/monthly-platform-earning`, {
    headers: authHeader(),
    params: buildScopeParams(params),
  });

const analyticsService = {
  overview,
  ordersByStatus,
  topProducts,
  salesByCategory,
  monthlyPlatformEarning,
};

export default analyticsService;

